import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  currentProductionEnvName: 'app_production',
  intercomAppId: '$$ZGUI_DATA_INTERCOM_APP_ID$$',
  enableIntercom: '$$ZGUI_DATA_ENABLE_INTERCOM$$',
  noolaKey: '$$ZGUI_DATA_NOOLA_KEY$$',
  enableNoola: '$$ZGUI_DATA_ENABLE_NOOLA$$',
  documentationUrl: '$$ZGUI_DATA_DOCS_URL$$',
  projectInfoUrl: 'https://info.zerops.io/',
  forceSecuredWebsocket: true,
  versionInfoPath: '/assets/version.json',
  rollbarAccessToken: 'd270c426ea76465781ad6bb512eb7ef0',
  envName: 'alpha',
  appVersion: 'z0-zbox',
  githubAuthCallbackUrl: 'https://alpha.devel.zerops.dev/github-auth',
  gitlabAuthCallbackUrl: 'https://alpha.devel.zerops.dev/gitlab-auth',
  apiUrl: 'https://api.app-alpha.zerops.dev/api/rest/public',
  webApiUrl: 'https://api.zerops.io',
  websocketHost: 'api.app-alpha.zerops.dev',
  websocketLoginUrl: 'https://api.app-alpha.zerops.dev/api/rest/public/web-socket/login',
  googleSiteKey: '6LdUw48UAAAAALnxsH_vUxMNlAVWrCvd-OS-g2nC',
  stripePublishableKey: 'pk_test_51U943uLfZVbKlxEjrh4Wut5PLUOoXpxkWC7laG7KoQ86e2Y8eqF7uoBoQHPx6jofeENH2xP9AZWbYpjMPM74sGBd00iJ6D8hZP',
  sharedIPv4: '$$ZGUI_DATA_SHARED_IPV4$$',
  region: 'zerops',
  hideVersionWarning: '$$ZGUI_HIDE_VERSION_WARNING$$',
  enableRemoteShell: '$$ZGUI_ENABLE_REMOTE_SHELL$$',
  enableMultiregion: '$$ZGUI_DATA_ENABLE_MULTIREGION$$',
  enableControlPlane: 'true',
  enableRecipesCategories: '$$ZGUI_ENABLE_RECIPES_CATEGORIES$$',
  enableRecipesLinks: '$$ZGUI_ENABLE_RECIPES_LINKS$$',
  turnstileToken: '0x4AAAAAABkfatE2McOoVj6p',
  cookieDomain: '$$ZGUI_DATA_COOKIE_DOMAIN$$',
  zcpVersion: '$$ZGUI_DATA_ZCP_VERSION$$',
  enableMultiAgentHandoff: '$$ZGUI_ENABLE_MULTI_AGENT_HANDOFF$$',
  simulateZcpPoolClaim: '$$ZGUI_ENABLE_SIMULATE_ZCP_POOL_CLAIM$$'
};
